import { RoleService } from '../../services/role.service';

export const FiRoleStateResolveAllRoles = [RoleService, FiRoleStateResolveAllRoles_resolveFunc];

export function FiRoleStateResolveAllRoles_resolveFunc(roleService: RoleService) {
    return roleService.getLightWeightRoles();
}
